package gr.tech.GRAttestation.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import gr.tech.GRAttestation.styles.grstyles.DefaultHorizontalStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.*

/*
    ============================
        Overlay Style
    ============================
 */

val OverlayBoxStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .zIndex(1)
            .fillMaxSize()
            .backgroundColor(Theme.MediumGreen.rgb)
    }
}


/*
    ============================
        Generated Form Styles
    ============================
 */

val GenHorizontalDivider = CssStyle {
    base {
        DefaultHorizontalStyle
            .borderTop(1.px, LineStyle.Solid, Colors.Black)
            .opacity(1)
            .backgroundColor(Colors.Black)
    }
}

val GenDefaultText = Modifier
    .fontFamily(FONT_FAMILY)
    .fontSize(1.cssRem)
    .lineHeight(1.25)
    .margin(topBottom = 0.px)

val GenHeaderLogoStyle = CssStyle {
    base {
        Modifier
            .width(275.px)
            .height(autoLength)
            .margin(leftRight = autoLength)
    }
}

val GenHeaderStyle = CssStyle {
    base {
        GenDefaultText
            .fillMaxWidth()
            .textAlign(TextAlign.Center)
            .fontWeight(FontWeight.Bold)
            .fontSize(1.cssRem)
    }
}

val GenSalesDataCount = CssStyle {
    base {
        GenDefaultText
            .color(Theme.DarkGreen.rgb)
            .margin(left = 16.px)
            .fontSize(1.5.cssRem)
            .fontWeight(FontWeight.Bold)
    }
}

val GenTableColumnHeader = CssStyle {
    base {
        Modifier
            .fontSize(0.7.cssRem)
            .fontWeight(FontWeight.Bold)
            .textAlign(TextAlign.Start)
            .padding(5.px)
            .backgroundColor(Colors.WhiteSmoke)
            .border(1.px, LineStyle.Solid, Colors.Black)
    }
}

val GenTableColumn = CssStyle {
    base {
        Modifier
            .padding(5.px)
            .border(1.px, LineStyle.Solid, Colors.Black)
    }
}

/*
    ============================
        Receipt Page Styles
    ============================
 */

val receiptPageStyle = CssStyle {
    base {
        Modifier
            .width(970.px) //exact width for format: a4
            .height(1100.px) //1344
            .padding(all = 8.px)
            .border(1.px, LineStyle.Solid, Colors.Black)
            .position(Position.Relative)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .overflow(Overflow.Hidden)
    }
}

val ReceiptsContainerStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Row)
            .flexWrap(FlexWrap.Wrap)
            .justifyContent(JustifyContent.Center)
            .gap(8.px)
            .fillMaxWidth()
    }
}

val ReceiptTextStyle = CssStyle {
    base {
        GenDefaultText
            .fontSize(0.7.cssRem)
    }
}

val ReceiptTableColumnHeader = CssStyle {
    base {
        Modifier
            .fontSize(0.6.cssRem)
            .fontWeight(FontWeight.Medium)
            .textAlign(TextAlign.Start)
            .padding(0.px)
    }
}

val ReceiptTableColumn = CssStyle {
    base {
        Modifier
            .fontSize(0.6.cssRem)
    }
}
